var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#555555"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6037_3905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05263 9.72315V12.2768C6.05263 12.677 6.40526 13 6.84211 13C7.27895 13 7.63158 12.677 7.63158 12.2768V9.72315C7.63158 9.32301 7.27895 9 6.84211 9C6.40526 9 6.05263 9.32301 6.05263 9.72315ZM9.21053 9.72315V12.2768C9.21053 12.677 9.56316 13 10 13C10.4368 13 10.7895 12.677 10.7895 12.2768V9.72315C10.7895 9.32301 10.4368 9 10 9C9.56316 9 9.21053 9.32301 9.21053 9.72315ZM5.78947 15H14.2105C14.6474 15 15 14.677 15 14.2768C15 13.8767 14.6474 13.5537 14.2105 13.5537H5.78947C5.35263 13.5537 5 13.8767 5 14.2768C5 14.677 5.35263 15 5.78947 15ZM12.3684 9.72315V12.2768C12.3684 12.677 12.7211 13 13.1579 13C13.5947 13 13.9474 12.677 13.9474 12.2768V9.72315C13.9474 9.32301 13.5947 9 13.1579 9C12.7211 9 12.3684 9.32301 12.3684 9.72315ZM9.51053 5.11209L5.35263 7.11763C5.13684 7.21887 5 7.42618 5 7.64794C5 7.9806 5.29474 8.25057 5.65789 8.25057H14.3474C14.7053 8.25057 15 7.9806 15 7.64794C15 7.42618 14.8632 7.21887 14.6474 7.11763L10.4895 5.11209C10.1842 4.96264 9.81579 4.96264 9.51053 5.11209Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6037_3905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCex);
export default __webpack_public_path__ + "static/media/ic_cex.74a995b53b1ef1405095830a54702e16.svg";
export { ForwardRef as ReactComponent };